export default "__VITE_ASSET__91b59990__"